var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.submissions.length,
          expression: "submissions.length",
        },
      ],
      staticClass: "tenant-view-comments",
    },
    [
      _c(
        "ul",
        { staticClass: "tenant-view-comments__list" },
        _vm._l(_vm.submissions, function (item, index) {
          return _c(
            "li",
            { key: index, staticClass: "tenant-view-comments__list--item" },
            [
              _c(
                "a",
                {
                  class: {
                    "comments-batch-number__link": item.completedDate,
                    "comments-batch-number": true,
                  },
                  on: {
                    click: function () {
                      return (
                        item.completedDate &&
                        _vm.showCommentsDetail(
                          item,
                          _vm.submissions.length - 1 - index
                        )
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        item.completedDate
                          ? _vm.$t(
                              "tenantProjects.tenantViewComments.batchNumberComments",
                              [item.order + 1]
                            )
                          : _vm.$t(
                              "tenantProjects.tenantViewComments.batchNumber",
                              [item.order + 1]
                            )
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "comments-batch-date" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getCommentActionText(item)) +
                    "\n      "
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.isTenant
        ? _c(
            "div",
            {
              staticClass: "reveal",
              attrs: { id: "showBatchCommentsDetailModal", "data-reveal": "" },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("CommentsPreviewBody", {
                attrs: {
                  activeBatch: _vm.activeBatch,
                  showRecipientsReadOnly: true,
                },
              }),
              _vm._v(" "),
              _c("TenantSubmissionDocuments", {
                attrs: {
                  files: _vm.files,
                  sourceId: (_vm.activeBatch || {}).id || "",
                  canEdit: false,
                },
                on: {
                  "update:files": function ($event) {
                    _vm.files = $event
                  },
                },
              }),
            ],
            1
          )
        : _c("EngineerSubmissionModal", {
            ref: "engineerSubmissionModal",
            attrs: { displayBatchIndex: _vm.displayBatchIndex },
          }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close-button",
        attrs: {
          "data-close": "",
          "aria-label": "Close modal",
          type: "button",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }